import React, { useContext, useMemo } from 'react'
import { ImageLoader } from '@usap/uicomponents'
import { BoxWithPointer } from '@usap/widgets'
import SearchConfig from '../../searchConfig'

import { LocalContext } from '../../../../helpers/useLocalContext'

export default function Image(props) {
  const {
    productIndex,
    productImage,
    productUri,
    skipVehicleLink,
    imgTitle,
    className,
    brand,
    index,
    sku,
    onClick,
  } = props

  const { aboveTheFoldImages } = SearchConfig

  const { localContext } = useContext(LocalContext)
  const { Link, isBot } = localContext

  const style = useMemo(() => (
    {
      margin: { large: 'medium', other: { vertical: 'medium' } },
      align: { large: 'center', other: 'start' },
      justify: { large: 'center', other: 'start' },
      height: { large: '210px', other: '140px' },
    }
  ), [])

  const noLazy = useMemo(
    () => productIndex < aboveTheFoldImages,
    [aboveTheFoldImages, productIndex],
  )

  return (
    <Link
      to={productUri}
      skip={skipVehicleLink}
      onClick={onClick}
      aria-label={`image-${brand} ${imgTitle}-${sku}-${index}`}
    >
      <BoxWithPointer
        fxMargin={style.margin}
        fxAlign={style.align}
        fxJustify={style.justify}
        fxHeight={style.height}
      >
        <ImageLoader
          className={className}
          height="100%"
          width="100%"
          layout="fixed"
          fit="contain"
          src={productImage}
          alt={imgTitle}
          isBot={isBot}
          cloudinaryParams="h_210,w_210"
          fallback="https://cld.partsimg.com/image/upload/noimage.jpg"
          noLazyLoad={noLazy}
        />
      </BoxWithPointer>
    </Link>
  )
}
